<template>
  <div class="md-layout md-alignment-center-center container gray-6 bg">
    <p v-if="error" class="error">
      {{
        error.message ||
          error.errorDescription ||
          "Unkown error when accepting invite"
      }}
    </p>
    <router-link v-if="error" to="login">Back to login</router-link>
    <h3 v-if="loading">Accepting invite...</h3>
    <md-progress-spinner v-if="loading" md-mode="indeterminate" />
  </div>
</template>

<script>
export default {
  name: 'invite-token-handler',
  props: {
    error: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  async mounted() {
    this.$emit('acceptInvite');
  },
};
</script>

<style>
.container {
  flex-direction: column;
}
</style>
